import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BtnStyle } from '../../../../_models/client/btn-style.model';

@Component({
  selector: 'app-text-modal',
  templateUrl: './text-modal.component.html',
  styleUrls: ['./text-modal.component.scss']
})
export class TextModalComponent {

  @Input() title = ''; // header címe

  @Input() body = ''; // body-ban megjelenő szöveg

  @Input() value = ''; // body szövegébe érték átadása

  @Input() link = false; // az előző value link típus-e

  @Input() warning: string | null = null; // sárga dobozos warning üzenet

  @Input() showDismiss = true; // dismiss btn megjelenítése

  @Input() dismissLabel = 'COMMON.CANCEL'; // default dismiss btn label

  @Input() closeLabel = 'COMMON.YES'; // default close btn label

  @Input() btnStyle: BtnStyle = BtnStyle.Primary; // default close btn style

  constructor(public activeModal: NgbActiveModal) {
  }

  initConfirmModal(title: string, body: string, value: string = '', warning = null): void {
    this.title = title;
    this.body = body;
    this.value = value;
    this.warning = warning;
  }

  initInfoModal(title: string, body: string, value: string = '', link: boolean = false): void {
    this.title = title;
    this.closeLabel = 'COMMON.OK';
    this.body = body;
    this.value = value;
    this.showDismiss = false;
    this.link = link;
  }

  initConfirmDeleteModal(value: string, warning = null): void {
    this.title = 'COMMON.DELETE';
    this.closeLabel = 'COMMON.DELETE';
    this.body = 'COMMON.CONFIRM_DELETE';
    this.btnStyle = BtnStyle.Danger;
    this.value = value;
    this.warning = warning;
  }

  initConfirmDiscardChangesModal(value: string): void {
    this.title = 'COMMON.DISCARD_CHANGES';
    this.body = 'COMMON.CONFIRM_DISCARD_CHANGES';
    this.btnStyle = BtnStyle.Danger;
    this.value = value;
  }

  initEmailUnsentModal(value: string): void {
    this.title = 'COMMON.SEND_EMAIL';
    this.body = 'COMMON.NOT_SENT';
    this.closeLabel = 'COMMON.OK';
    this.value = value;
    this.showDismiss = false;
  }
}
